export interface EllipsisTheme {
  /** CSS class applied to the ellipsis dots toggle element. */
  dots: string;
}

const baseTheme: EllipsisTheme = {
  dots: 'cursor-pointer opacity-50 text-[unset] p-0 border-[none] outline-hidden'
};

export const ellipsisTheme: EllipsisTheme = {
  ...baseTheme
};
